function addEventListeners (eventBus,eventListeners) {
  eventListeners.forEach((e) => {
    eventBus.$on(e.name,e.func)
  });
}

function removeEventListeners (eventBus,eventListeners) {
  eventListeners.forEach((e) => {
    eventBus.$off(e.name,e.func)
  });
}

function addScript(url,replace){
  let s = document.querySelector("script[src='"+url+"']")
  if(s && replace){
    s.remove();
    s = null;
  }
  if(!s){
    let el = document.createElement('script')
    el.setAttribute('src', url)
    document.head.appendChild(el)
  }
}

export {
  addEventListeners,
  removeEventListeners,
  addScript
}
